import { EventTypeGroupConfigChangeBM } from '../types/BusinessModel/EventTypeGroupConfigChangeBM';
import { EventTypeGroupConfigChange } from '../types/ViewModel/EventTypeGroupConfigChange';

export class EventTypeGroupConfigChangeFactory {
    constructor() {}

    public newEventTypeGroupConfigChangeList(evTypeGrCfgChangeListBM: EventTypeGroupConfigChangeBM[]): EventTypeGroupConfigChange[] {
        const evTypeGrCfgChangeList: EventTypeGroupConfigChange[] = [];
        if (evTypeGrCfgChangeListBM && evTypeGrCfgChangeListBM.length > 0) {
            evTypeGrCfgChangeListBM.forEach((cmItem) => {
                evTypeGrCfgChangeList.push(this.createEventTypeGroupConfigChangeItem(cmItem));
            });
        }
        return evTypeGrCfgChangeList;
    }

    private createEventTypeGroupConfigChangeItem(item: EventTypeGroupConfigChangeBM): EventTypeGroupConfigChange {
        return new EventTypeGroupConfigChange(
            item.eventTypeGroupConfigChangeId,
            item.eventTypeGroupId,
            item.from,
            item.to,
            item.mandatory,
            item.multiple,
            item.concurrent,
            item.ordered,
            item.requiredPreviousTypeId,
            item.requiredPreviousTypeIdForceNull,
            item.requiredPreviousSameTypeId,
            item.requiredPreviousSameTypeIdForceNull,
            item.notAfterEventTypeId,
            item.notAfterEventTypeIdForceNull,
            item.enabledFrom,
            item.enabledFromForceNull,
            item.deleted
        );
    }
}
